import React, { useState } from "react";
import CashBalanceTotals from "./CashBalanceTotals";
import ExpenseTotals from "./ExpenseTotals";
import IncomeTotals from "./IncomeTotals";
import PotentialBalanceTotals from "./PotentialBalanceTotals";
import PotentialProfitTotals from "./PotentialProfitTotals";
import ProfitTotals from "./ProfitTotals";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function TotalsTable({
  incomes,
  expenses,
  profits,
  potentialIncomes,
  potentialExpenses,
  startBalance,
  cashBalance,
  setCashBalance,
  potentialCashBalance,
  setPotentialCashBalance,
  tableHeads,
  deleteMonth,
}) {
  const [potentialProfit, setPotentialProfit] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  return (
    <div>
      <table className="totalsTable">
        <thead className="totalsTableheadborder">
          <tr>
            <th className="col-2 alignCentre">
              <h3 className="ms-5 mt-2">Totals</h3>
            </th>
            {Object.keys(tableHeads).map((month, i, { length }) => {
              if (i === 0) {
                return (
                  <th className="">
                    <FontAwesomeIcon
                      className="black clickable me-2"
                      onClick={() => {
                        deleteMonth(i);
                      }}
                      icon={faTrash}
                    />
                    {tableHeads[month].slice(0, 3)}
                  </th>
                );
              } else {
                return <th className="">{tableHeads[month].slice(0, 3)}</th>;
              }
            })}
          </tr>
        </thead>
        <tbody>
          <IncomeTotals incomes={incomes} />
          <ExpenseTotals expenses={expenses} />
          <ProfitTotals profits={profits} />
          <CashBalanceTotals
            profits={profits}
            startBalance={startBalance}
            cashBalance={cashBalance}
            setCashBalance={setCashBalance}
          />
          <tr>
            <td className="hideBorders" colSpan={14}></td>
          </tr>
          <PotentialProfitTotals
            incomes={incomes}
            potentialIncomes={potentialIncomes}
            expenses={expenses}
            potentialExpenses={potentialExpenses}
            potentialProfit={potentialProfit}
            setPotentialProfit={setPotentialProfit}
          />
          <PotentialBalanceTotals
            potentialProfit={potentialProfit}
            startBalance={startBalance}
            potentialCashBalance={potentialCashBalance}
            setPotentialCashBalance={setPotentialCashBalance}
          />
        </tbody>
      </table>
    </div>
  );
}
